import { Button, Tooltip } from 'antd';
import { VerticalAlignBottomOutlined, VerticalAlignTopOutlined } from '@ant-design/icons';

interface ScrollButtonProps {
    registros: any;
    onClick: () => void;
}

export const ScrollToBottomButton = ({ registros, onClick }: ScrollButtonProps) => {
    if (registros.length < 50) return null;
    return (
        <Tooltip title="Ir para o fim da tabela">
            <Button
                size="small"
                style={{ marginRight: 8 }}
                icon={<VerticalAlignBottomOutlined />}
                onClick={onClick}
            />
        </Tooltip>
    );
};

export const ScrollToTopButton = ({ registros, onClick }: ScrollButtonProps) => {
    if (registros.length < 50) return null;
    return (
        <Tooltip title="Ir para o topo da tabela">
            <Button
                size="small"
                style={{ marginRight: 8 }}
                icon={<VerticalAlignTopOutlined />}
                onClick={onClick}
            />
        </Tooltip>
    );
};
